import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
      <a href="https://github.com/jadamswalton" target="_blank" rel="noreferrer"><GitHubIcon/></a>
      <a href="https://www.linkedin.com/in/jadamswalton/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
      </div>
      <p> J. Adams Walton | 2025</p>
    </footer>
  );
}

export default Footer;